const logs = {
    page_title: 'Audit logs',
    title: 'Audit logs',
    subtitle: 'View log data of authentication events made by your users',
    event: 'Event',
    user: 'User',
    application: 'Application',
    time: 'Time',
    filter_by: 'Filter by',
    last_1_hour: 'Last 1 hour',
    last_24_hours: 'Last 24 hours',
    last_7_days: 'Last 7 days',
    last_30_days: 'Last 30 days',
    custom_range: 'Custom range',
    from: 'From',
    to: 'To',
};
export default Object.freeze(logs);
